<div 
  [ngClass]="{'smartlabel-page': isSmartlabelMode }"
  [ngStyle]="getPaddingBottom()"
  style="
    overflow: auto;
    width: 100%;
    min-height: 100%;">
  <app-content-control *ngIf="contentControls" [contentControls]="contentControls"></app-content-control>
</div>
